import axiosInstance from 'client';
import * as dto from 'client/dto';

/** SOURCE: DiseaseActivityController.GetCountryDiseaseActivityUpdates */
function GetCountryDiseaseActivityUpdates(payload: {
  countryId: number;
  diseaseId: number;
  speciesId: number;
  activityDate: string;
  offset: number;
  excludeCaseCounts: boolean;
}): Promise<dto.DailyActivityListModel> {
  const { countryId, diseaseId, speciesId, activityDate, offset, excludeCaseCounts } = payload;
  return axiosInstance
    .get(
      `/api/activity/disease/${diseaseId}/species/${speciesId}/country/${countryId}/summary/${activityDate}`,
      {
        params: { countryId, diseaseId, speciesId, activityDate, offset, excludeCaseCounts },
      }
    )
    .then(({ data }) => data);
}

/** SOURCE: DiseaseActivityController.GetGlobalDiseaseActivityUpdates */
function GetGlobalDiseaseActivityUpdates(payload: {
  diseaseId: number;
  speciesId: number;
  activityDate: string;
  offset: number;
  excludeCaseCounts: boolean;
}): Promise<dto.DailyActivityListModel> {
  const { diseaseId, speciesId, activityDate, offset, excludeCaseCounts } = payload;
  return axiosInstance
    .get(`/api/activity/disease/${diseaseId}/species/${speciesId}/summary/${activityDate}`, {
      params: { diseaseId, speciesId, activityDate, offset, excludeCaseCounts },
    })
    .then(({ data }) => data);
}

/** SOURCE: DiseaseActivityController.GetNewerCountryDiseaseActivityUpdates */
function GetNewerCountryDiseaseActivityUpdates(payload: {
  countryId: number;
  diseaseId: number;
  speciesId: number;
  activityDate: string;
  count: number;
  excludeCaseCounts: boolean;
}): Promise<dto.DailyActivityListModel> {
  const { countryId, diseaseId, speciesId, activityDate, count, excludeCaseCounts } = payload;
  return axiosInstance
    .get(
      `/api/activity/disease/${diseaseId}/species/${speciesId}/country/${countryId}/summary/${activityDate}/newer`,
      {
        params: { countryId, diseaseId, speciesId, activityDate, count, excludeCaseCounts },
      }
    )
    .then(({ data }) => data);
}

/** SOURCE: DiseaseActivityController.GetOlderCountryDiseaseActivityUpdates */
function GetOlderCountryDiseaseActivityUpdates(payload: {
  countryId: number;
  diseaseId: number;
  speciesId: number;
  activityDate: string;
  count: number;
  excludeCaseCounts: boolean;
}): Promise<dto.DailyActivityListModel> {
  const { countryId, diseaseId, speciesId, activityDate, count, excludeCaseCounts } = payload;
  return axiosInstance
    .get(
      `/api/activity/disease/${diseaseId}/species/${speciesId}/country/${countryId}/summary/${activityDate}/older`,
      {
        params: { countryId, diseaseId, speciesId, activityDate, count, excludeCaseCounts },
      }
    )
    .then(({ data }) => data);
}

/** SOURCE: DiseaseActivityController.GetNewerGlobalDiseaseActivityUpdates */
function GetNewerGlobalDiseaseActivityUpdates(payload: {
  diseaseId: number;
  speciesId: number;
  activityDate: string;
  count: number;
  excludeCaseCounts: boolean;
}): Promise<dto.DailyActivityListModel> {
  const { diseaseId, speciesId, activityDate, count, excludeCaseCounts } = payload;
  return axiosInstance
    .get(`/api/activity/disease/${diseaseId}/species/${speciesId}/summary/${activityDate}/newer`, {
      params: { diseaseId, speciesId, activityDate, count, excludeCaseCounts },
    })
    .then(({ data }) => data);
}

/** SOURCE: DiseaseActivityController.GetOlderGlobalDiseaseActivityUpdates */
function GetOlderGlobalDiseaseActivityUpdates(payload: {
  diseaseId: number;
  speciesId: number;
  activityDate: string;
  count: number;
  excludeCaseCounts: boolean;
}): Promise<dto.DailyActivityListModel> {
  const { diseaseId, speciesId, activityDate, count, excludeCaseCounts } = payload;
  return axiosInstance
    .get(`/api/activity/disease/${diseaseId}/species/${speciesId}/summary/${activityDate}/older`, {
      params: { diseaseId, speciesId, activityDate, count, excludeCaseCounts },
    })
    .then(({ data }) => data);
}

/** SOURCE: DiseaseActivityController.GetHierarchicalDiseaseActivityUpdates */
function GetHierarchicalDiseaseActivityUpdates(payload: {
  diseaseId: number;
  speciesId: number;
  locationId: number;
  activityDate: string;
  offset: number;
  excludeCaseCounts: boolean;
}): Promise<dto.DailyActivityListModel> {
  const { diseaseId, speciesId, locationId, activityDate, offset, excludeCaseCounts } = payload;
  return axiosInstance
    .get(
      `/api/activity/disease/${diseaseId}/species/${speciesId}/location/${locationId}/summary/${activityDate}`,
      {
        params: { diseaseId, speciesId, locationId, activityDate, offset, excludeCaseCounts },
      }
    )
    .then(({ data }) => data);
}

/** SOURCE: DiseaseActivityController.GetNewerHierarchicalDiseaseActivityUpdates */
function GetNewerHierarchicalDiseaseActivityUpdates(payload: {
  diseaseId: number;
  speciesId: number;
  locationId: number;
  activityDate: string;
  count: number;
  excludeCaseCounts: boolean;
}): Promise<dto.DailyActivityListModel> {
  const { diseaseId, speciesId, locationId, activityDate, count, excludeCaseCounts } = payload;
  return axiosInstance
    .get(
      `/api/activity/disease/${diseaseId}/species/${speciesId}/location/${locationId}/summary/${activityDate}/newer`,
      {
        params: { diseaseId, speciesId, locationId, activityDate, count, excludeCaseCounts },
      }
    )
    .then(({ data }) => data);
}

/** SOURCE: DiseaseActivityController.GetOlderHierarchicalDiseaseActivityUpdates */
function GetOlderHierarchicalDiseaseActivityUpdates(payload: {
  diseaseId: number;
  speciesId: number;
  locationId: number;
  activityDate: string;
  count: number;
  excludeCaseCounts: boolean;
}): Promise<dto.DailyActivityListModel> {
  const { diseaseId, speciesId, locationId, activityDate, count, excludeCaseCounts } = payload;
  return axiosInstance
    .get(
      `/api/activity/disease/${diseaseId}/species/${speciesId}/location/${locationId}/summary/${activityDate}/older`,
      {
        params: { diseaseId, speciesId, locationId, activityDate, count, excludeCaseCounts },
      }
    )
    .then(({ data }) => data);
}

// DiseaseActivityHistoryApi
export default {
  GetCountryDiseaseActivityUpdates,
  GetGlobalDiseaseActivityUpdates,
  GetNewerCountryDiseaseActivityUpdates,
  GetNewerGlobalDiseaseActivityUpdates,
  GetOlderCountryDiseaseActivityUpdates,
  GetOlderGlobalDiseaseActivityUpdates,
  GetHierarchicalDiseaseActivityUpdates,
  GetNewerHierarchicalDiseaseActivityUpdates,
  GetOlderHierarchicalDiseaseActivityUpdates,
};
